import { AbstractEntity, PropertyValuesDictionary, Transaction, UiData } from "plethora-lib" // GENERATED
import {
  DataTypeShapeType,
  DataTypeDirection,
  DataTypeSize,
  DataTypeColor,
} from "../GeneratedClasses/GeneratedDataTypes" // GENERATED
import { GeneratedShape } from "../GeneratedClasses/GeneratedShape" // GENERATED

export class Shape extends GeneratedShape {
  constructor(id: number, propertyValues: PropertyValuesDictionary, uiData: UiData) {
    super(id, propertyValues, uiData)

    const data = {
      id: this.id,
      shapeType: this.getType(),
      shapeSize: this.getSize(),
      shapeColor: this.getColor(),
      posX: this.getX(),
      posY: this.getY(),
      jsonTxt: uiData,
    }
    gameInstance.SendMessage("GridManager", "CreateShapePlethora", JSON.stringify(data))
  }

  public onDelete(uiData: UiData): void /* GENERATED */ {
    super.onDelete(uiData)
    // YOUR CODE HERE
    gameInstance.SendMessage("GridManager", "DestroyShape", this.id)
  }

  public onDestory(): void /* GENERATED */ {
    super.onDestory()
    // YOUR CODE HERE
  }

  public onSetHighlight(highlight: boolean): void /* GENERATED */ {
    super.onSetHighlight(highlight)
    // YOUR CODE HERE
  }

  protected onSizeUpdate(newValue: DataTypeSize, oldValue: DataTypeSize, uiData: UiData): void /* GENERATED */ {
    const data = {
      id: this.id,
      shapeSize: newValue,
    }
    gameInstance.SendMessage("GridManager", "ChangeSize", JSON.stringify(data))
  }

  protected onColorUpdate(newValue: DataTypeColor, oldValue: DataTypeColor, uiData: UiData): void /* GENERATED */ {
    const data = {
      id: this.id,
      shapeColor: newValue,
    }
    gameInstance.SendMessage("GridManager", "ChangeColor", JSON.stringify(data))
  }

  protected onTypeUpdate(
    newValue: DataTypeShapeType,
    oldValue: DataTypeShapeType,
    uiData: UiData
  ): void /* GENERATED */ {
    // YOUR CODE HERE
  }

  protected onDirectionUpdate(
    newValue: DataTypeDirection,
    oldValue: DataTypeDirection,
    uiData: UiData
  ): void /* GENERATED */ {
    // YOUR CODE HERE
  }

  protected onXUpdate(newValue: number, oldValue: number, uiData: UiData): void /* GENERATED */ {
    // YOUR CODE HERE
  }

  protected onYUpdate(newValue: number, oldValue: number, uiData: UiData): void /* GENERATED */ {
    // YOUR CODE HERE
  }

  protected onMove(direction: DataTypeDirection, uiData: UiData): void /* GENERATED */ {
    // YOUR CODE HERE
  }

  protected onTurnDown(uiData: UiData): void /* GENERATED */ {
    gameInstance.SendMessage("GridManager", "ShapeRotate", this.id)

    // YOUR CODE HERE
  }

  protected onTurnUp(uiData: UiData): void /* GENERATED */ {
    gameInstance.SendMessage("GridManager", "ShapeRotate", this.id)
    // YOUR CODE HERE
  }

  protected onTurnRight(uiData: UiData): void /* GENERATED */ {
    gameInstance.SendMessage("GridManager", "ShapeRotate", this.id)
    // YOUR CODE HERE
  }

  protected onTurnLeft(uiData: UiData): void /* GENERATED */ {
    gameInstance.SendMessage("GridManager", "ShapeRotate", this.id)
    // YOUR CODE HERE
  }

  protected onStep1(uiData: UiData): void /* GENERATED */ {
    const data = {
      id: this.id,
      shapeSteps: 1,
    }
    gameInstance.SendMessage("GridManager", "ShapeOnSteps", JSON.stringify(data))
    // YOUR CODE HERE
  }

  protected onStep3(uiData: UiData): void /* GENERATED */ {
    const data = {
      id: this.id,
      shapeSteps: 3,
    }
    gameInstance.SendMessage("GridManager", "ShapeOnSteps", JSON.stringify(data))
    // YOUR CODE HERE
  }

  protected onStep2(uiData: UiData): void /* GENERATED */ {
    const data = {
      id: this.id,
      shapeSteps: 2,
    }
    console.log(data.id, data.shapeSteps)
    gameInstance.SendMessage("GridManager", "ShapeOnSteps", JSON.stringify(data))
    // YOUR CODE HERE
  }

  protected onClick(uiData: UiData): void /* GENERATED */ {
    // YOUR CODE HERE
  }

  protected onMeets(isActivator: boolean, otherEntity: AbstractEntity, uiData: UiData): void /* GENERATED */ {
    // YOUR CODE HERE
  }
}
